<div class="dialog-header">
  <h2 mat-dialog-title>Ouvidoria</h2>
  <button matIconButton mat-dialog-close aria-label="Fechar">
    <span class="material-symbols-outlined" aria-hidden="true">close</span>
  </button>
</div>
<mat-dialog-content>
  <p><b>Ouvidoria Pinpag</b></p>
  <p>Telefone: (11) 4223-7590</p>
  <p>Email: ouvidoria&#64;pinpag.com.br</p>

  <p><b>Ouvidoria Banco Rendimento</b></p>
  <p>Telefone: 0800 722 0132 (Atendimento de segunda a sexta, exceto feriados, das 9h às 18h)</p>
  <a href="https://www.rendimento.com.br/ouvidoria/" target="_blank" rel="noopener">
    Site: https://www.rendimento.com.br/ouvidoria/
  </a>
</mat-dialog-content>
